/**
 * Polska odmiana rzeczownika po liczebniku: 1 gem · 2–4 gemy · 5+ gemów.
 * Wyjątek: 12–14 (i 112–114 itd.) biorą formę „many" („12 gemów"), a 22–24
 * znowu „few" („22 gemy").
 *
 * Formy dotyczą mianownika/biernika („Cena: 3 gemy", „za 3 gemy",
 * „Sprzedano 2 pety"). Po czasowniku z dopełniaczem („użyj", „potrzeba")
 * odmiana jest inna — tam przeformułuj zdanie, zamiast wołać ten helper.
 *
 * Emoji waluty w tekście jest zakazane (UI bez emoji), więc słowo musi być
 * poprawne gramatycznie — stała forma „gemów" dawała „za 1 gemów".
 */
export function pluralPl(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(Math.trunc(n));
  if (abs === 1) return one;
  const lastDigit = abs % 10;
  const lastTwo = abs % 100;
  return lastDigit >= 2 && lastDigit <= 4 && (lastTwo < 12 || lastTwo > 14) ? few : many;
}

/** „1 gem", „3 gemy", „5 gemów" — kwoty w gemach w komunikatach i podpowiedziach. */
export function gemWord(n: number): string {
  return pluralPl(n, 'gem', 'gemy', 'gemów');
}
